<div *ngIf="person">
    <div *ngIf="canEdit()" class="flex flex-row flex-wrap justify-content-center gap-3 my-5">
        <p-button class="grey" label="Ver estadísticas" icon="pi pi-chart-line" (click)="goToDetail()" ariaLabel="Ver estadísticas"></p-button>
        <p-button class="grey" label="Destacar" icon="pi pi-bolt" (click)="goToCreateActivity()" ariaLabel="Destacar" [disabled]="activityNumber >= 3"></p-button>
        <p-button class="grey" label="Servicio al cliente" icon="pi pi-question-circle" (click)="contactUs()" ariaLabel="Cambiar contraseña"></p-button>
        <p-button class="grey" label="Mejorar plan" icon="pi pi-star" (click)="upgrade()" ariaLabel="Mejorar plan"></p-button>
        <p-button *ngIf="isAdmin" class="grey" label="Suscripciones" icon="pi pi-tags" (click)="goToSubscriptionDetail()" ariaLabel="Suscripciones"></p-button>
    </div>
    <div *ngIf="canEdit()" class="flex flex-row flex-wrap justify-content-center gap-3 my-5">
        <p-button class="grey" label="Editar información" icon="pi pi-pencil" (click)="editProfile()" ariaLabel="Editar información"></p-button>
        <p-button class="grey" label="Cambiar número de teléfono" icon="pi pi-phone" (click)="editUsername()" ariaLabel="Cambiar número de teléfono"></p-button>
        <p-button class="grey" label="Modificar imágenes" icon="pi pi-images" (click)="editMedia()" ariaLabel="Modificar imágenes"></p-button>
        <p-button class="grey" label="Cambiar contraseña" icon="pi pi-lock" (click)="editPassword()" ariaLabel="Cambiar contraseña"></p-button>
    </div>
    <app-edit-password [(displayDialog)]="displayPasswordEdit" [userName]="person.user.userName">
    </app-edit-password>
    <app-edit-username [(displayDialog)]="displayUsernameEdit" [userName]="person.user.userName" [urlId]="person.url_id">
    </app-edit-username>
    <div class="flex flex-column flex-grow-1 align-items-center align-content-center gap-2 my-5">
        <div class="text-center">
            <h2 *ngIf="canEdit() && !person.visible" class="my-0 text-red-500"><span class="pi pi-times" style="font-size: 1.5rem"></span> Perfil no publicado</h2>
            <h1 class="my-0 text-xl">
                <span class="pi pi-user" style="font-size: 1.5rem"></span><span class="text-2xl"> {{ person.name }}</span><br>
                <span class="pi pi-info-circle"></span> {{ person.age }} años <br>
                <span class="pi pi-map-marker"></span> {{ person.city.name }} - {{ person.locality.name }}
            </h1>
        </div>
        <p class="my-0"><span class="pi pi-calendar"></span> {{ person.schedule }}</p>
        <p *ngIf="person.pricePerHour > 0" class="my-0"><span class="pi pi-dollar"></span> {{ person.pricePerHour | number: '1.0-0' : 'co' }} por hora</p>
        <div class="flex flex-row gap-2">
            <p-tag *ngIf="isNew(person)" icon="pi pi-star-fill" value="Nuevo" severity="warning"></p-tag>
            <p-tag *ngIf="person.verified === 1" icon="pi pi-check" value="Verificado"></p-tag>
            <p-tag *ngIf="isActive(person)" icon="pi pi-circle-fill" value="En línea" severity="success"></p-tag>
        </div>
        <div *ngIf="isAdmin" class="pt-5">
            <p-fieldset legend="Administración" styleClass="w-10 md:w-8 m-auto">
                <h4 class="my-0"><span class="pi pi-id-card"></span> {{ person.idDocument }}</h4>
                <p class="quote">{{ person.notes }}</p>
            </p-fieldset>
        </div>
    </div>
    <div class="flex flex-row flex-wrap gap-3 justify-content-evenly my-5">
        <button pButton label="{{ person.user.userName }}" (click)="contact()" icon="pi pi-phone" aria-label="Llamar"></button>
        <button pButton label="Contactar" (click)="contactWhatsapp()" icon="pi pi-whatsapp" 
            class="whatsapp" aria-label="Contactar por Whatsapp"></button>
    </div>
    <p-galleria [value]="person.mediaContent" [showThumbnails]="false" appendTo="body"
        [circular]="true" [fullScreen]="true" [(visible)]="showGallery" [(activeIndex)]="activeIndex" 
        [showItemNavigators]="true" [showThumbnailNavigators]="false" [showIndicators]="true" 
        [containerStyle]="{'text-align':'center', 'overflow':'visible'}" (keydown)="arrowKeyDown($event)"
        (touchstart)="touchStart($event)" (touchend)="touchEnd($event)">
        <ng-template pTemplate="item" let-media>
            <p-image *ngIf="media.type !== '.mp4'" src="{{ uploadLocation + media.fileName }}" imageClass="full-screen-image" 
                [alt]="'Imagen ' + media.order + ' de ' + person.name + ' ' + person.user.userName"></p-image>
            <video *ngIf="media.type === '.mp4'" width="90%" height="90%" controls controlsList="nodownload" src="{{ uploadLocation + media.fileName }}">
                
            </video>
        </ng-template>
    </p-galleria>
    <div *ngIf="person.mediaContent" class="flex flex-row flex-wrap w-full w-10 md:w-7 m-auto overflow-hidden">
        <div *ngFor="let image of person.mediaContent; let index = index" 
            class="w-4 h-6rem sm:h-10rem md:h-11rem lg:h-14rem xl:h-16rem p-1 m-0 overflow-hidden" key="index">
            <img *ngIf="image.type !== '.mp4'" [src]="thumbnailLocation + image.fileName" class="w-full overflow-hidden cursor-pointer" (click)="imageClick(index)" 
                [alt]="'Miniatura ' + image.order + ' de ' + person.name + ' ' + person.user.userName" />
            <div class="cursor-pointer relative h-full border-gray-400 border-solid border-1" (click)="imageClick(index)">
                <i class="pi pi-play absolute video-icon" style="font-size: 2.5rem; color: #fcfcfc;"></i>
                <video *ngIf="image.type === '.mp4'" width="auto" height="auto">
                    <source src="{{ uploadLocation + image.fileName }}#t=1">
                </video>
            </div>
        </div>
    </div>
    <div class="pt-5">
        <p-fieldset styleClass="w-10 md:w-8 m-auto">
            <ng-template pTemplate="header">
                <h2 class="text-lg font-normal">{{ person.name }} {{ person.user.userName }}</h2>
            </ng-template>
            <p class="quote">{{ person.description }}</p>
        </p-fieldset>
    </div>
    <div class="flex flex-row flex-wrap justify-content-center my-5 m-auto">
        <p-chip *ngFor="let servicePlace of person.servicePlaces" label="{{servicePlace.description}}" class="m-2"
            icon="{{ getIcon(servicePlace.description) }}"></p-chip>
    </div>
    <div class="flex flex-row flex-wrap justify-content-center my-5 m-auto">
        <p-chip *ngFor="let service of person.services" label="{{service.name}}" class="m-2"></p-chip>
    </div>
</div>
<div *ngIf="person === undefined" class="flex flex-column align-items-center gap-2">
    <p-skeleton width="250px" height="150px" styleClass="col-4 p-1 m-5"></p-skeleton>
    <div class="flex flex-row">
        <p-skeleton width="148.91px" height="38px" styleClass="mx-7"></p-skeleton>
        <p-skeleton width="108.91px" height="38px" styleClass="mx-7"></p-skeleton>
    </div>
    <div class="grid">
        <p-skeleton width="171.98px" height="171.98px" styleClass="col-4 p-1 m-1"></p-skeleton>
        <p-skeleton width="171.98px" height="171.98px" styleClass="col-4 p-1 m-1"></p-skeleton>
        <p-skeleton width="171.98px" height="171.98px" styleClass="col-4 p-1 m-1"></p-skeleton>
    </div>
    <p-skeleton width="50rem" height="10rem" styleClass="my-5"></p-skeleton>
</div>